import type { TransactionDetailsModel } from "@/features/collections/api/models/TransactionDetailsModel";
import type { TransactionDetailsSortOrder } from "@/features/collections/TransactionDetailsSortOrder";
import { useHTTP, useHTTPQueryWithCursor, type PaginatedResponseModel } from "@/lib/http";

export const useTransactionDetails = (collectionId: string, sortOrder: TransactionDetailsSortOrder, searchQuery: string, enabled = true) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["transactions", collectionId, sortOrder, searchQuery],
		enabled,
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<TransactionDetailsModel>>({
				method: "GET",
				url: `/collection/${collectionId}/transaction?cursor=${pageParam}&sortOrder=${sortOrder}` + (searchQuery.trim() ? `&searchQuery=${encodeURIComponent(searchQuery)}` : "")
			});
		}
	});
};
